import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/apiSlice";
import { calendarApiSlice } from "./slices/calendarApiSlice";
import authSlice from "./slices/authSlice";
import { leaveApiSlice } from "./slices/leaveApiSlice";
import { overtimeApiSlice } from "./slices/overtimeApiSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [calendarApiSlice.reducerPath]: calendarApiSlice.reducer,
    [leaveApiSlice.reducerPath]: leaveApiSlice.reducer,
    [overtimeApiSlice.reducerPath]: overtimeApiSlice.reducer,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      apiSlice.middleware,
      calendarApiSlice.middleware,
      leaveApiSlice.middleware,
      overtimeApiSlice.middleware
    ),
  devTools: true,
});

export default store;